export default __webpack_public_path__ + "static/media/sm5.c6ed5f22.png";